// @flow
import * as React from 'react';
import Dropzone from 'react-dropzone';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';

const Notice = styled.span`
  color: ${props => props.theme.colors.lightGray};
  font-size: 14px;
  font-style: italic;
  margin-left: ${props => props.theme.metrics.smallMargin}px;
`;

type Props = {
  label: string;
  onUpload: (file: File) => void;
  theme: any;
  t: any;
}

class FileUploadButton extends React.Component<Props> {
  onDrop(acceptedFiles: File[]) {
    if (acceptedFiles.length < 1) {
      return;
    }

    const file = acceptedFiles[0];
    this.props.onUpload(file);
  }

  toBytes(mb) {
    return mb * 1000000;
  }

  render() {
    const ONE_MB = 1;
    const { label, theme, t } = this.props;
    let dropZoneRef: any;

    return (
      <div style={{ marginTop: theme.metrics.margin }} >
        <Dropzone
          ref={(node) => {
            dropZoneRef = node;
          }}
          accept="image/jpeg, image/png"
          onDrop={(acceptedFiles, rejectedFiles) => this.onDrop(acceptedFiles)}
          multiple={false}
          style={{ display: 'none' }}
          maxSize={this.toBytes(ONE_MB)}
        />
        <RaisedButton
          onClick={() => dropZoneRef.open()}
          style={{ backgroundColor: theme.colors.primaryBackground }}
          labelStyle={{ color: theme.colors.primary }}
          label={label}
          icon={<i className="material-icons" style={{ color: theme.colors.primary }}>add_circle</i>}
        />
        <Notice>
          { t('fileUploadMaxSize', { limit: ONE_MB }) }
        </Notice>
      </div>
    );
  }
}

export default withTheme(translate('radioConfiguration')(FileUploadButton));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/FileUploadButton.js